import React from "react";
// Add this line to fix the 'no-undef' error:
import { getNodeTotalAmount } from "../utils/reportsHelpers";

function PendingItemsPanel({ pendingIds, nodeMap, onRestore, onRestoreAll }) {
  if (!pendingIds || pendingIds.length === 0) return null;

  return (
    <div className="card removed-items-panel">
      <div style={{ 
        display: 'flex', 
        alignItems: 'center', 
        gap: '12px', 
        marginBottom: '10px' 
      }}>
        <h3 className="panel-title" style={{ margin: 0 }}>
          Hidden Items
        </h3>
        
        <button 
          className="group-btn-primary" 
          onClick={onRestoreAll}
          style={{ 
            padding: '8px 14px',
            fontSize: '11px', 
            lineHeight: '1',
            height: 'auto',
            textTransform: 'uppercase',
            transform: 'translateY(6px)', 
            cursor: 'pointer',
            fontWeight: 'bold'
          }}
        >
          Restore All
        </button>
      </div>

      <p className="muted" style={{ marginBottom: '16px' }}>
        The following line items have been removed from the report view.
      </p>

      <div className="removal-group">
        <ul className="removal-group-list">
          {pendingIds.map((id) => {
            const node = nodeMap.get(id);
            if (!node) return null;

            // This is the line that was causing the error
            const total = getNodeTotalAmount(node);

            return (
              <li key={id} className="removal-item">
                <span className="removal-name">{node.name}</span>

                <div className="removal-item-right">
                  <span
                    className={`removal-amount ${
                      total < 0 ? "negative" : "positive"
                    }`}
                  >
                    {total.toLocaleString("en-US", {
                      style: "currency",
                      currency: "USD",
                    })}
                  </span>

                  <button
                    className="restore-inline-btn"
                    onClick={() => onRestore(id)}
                    title="Restore item"
                  >
                    Restore
                  </button>
                </div>
              </li>
            );
          })}
        </ul>
      </div>
    </div>
  );
}

export default PendingItemsPanel;